export const roleNames = {
  admin: 'admin',
  broker: 'broker',
  carrier: 'carrier',
  customer: 'customer',
  driver: 'driver',
  haulier: 'haulier',
  partner: 'partner',
  shipper: 'shipper',
  superAdmin: 'super-admin',
} as const

export const allRoleNames = Object.values(roleNames)

const roleNameSet = new Set<string>(allRoleNames)

export type RoleName = (typeof allRoleNames)[number]

export const isRoleName = (value: string): value is RoleName => roleNameSet.has(value)
